import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexPlotOptions,
  ApexXAxis,
  ApexFill,
  ApexDataLabels,
  ApexYAxis,
  ApexGrid,
  ApexTooltip,
  ApexTitleSubtitle,
} from 'ng-apexcharts';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  fill: ApexFill;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  plotOptions: ApexPlotOptions;
  tooltip: ApexTooltip;
  title: ApexTitleSubtitle;
};

@Component({
  selector: 'app-ns2200',
  templateUrl: './ns2200.component.html',
  styleUrls: ['./ns2200.component.css']
})
export class Ns2200Component implements OnInit {
  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  constructor() {
    this.chartOptions = {
      tooltip: {
        enabled: false
      },
      series: [
        {
          name: 'Inzet NS 2200',
          data: [{
            x: 'Piko 40440 2297 Bruin',
            y: [
              new Date('1957-07-01').getTime(),
              new Date('1960-01-31').getTime()
            ],
            fillColor: '#00E396'
          },
          {
            x: 'Piko 40418 2218 Bruin, A-licht',
            y: [
              new Date('1959-01-01').getTime(),
              new Date('1981-12-31').getTime()
            ],
            fillColor: '#008FFB'
          },

          {
            x: 'Piko 40443 2271 Bruin, Blauw zwl.',
            y: [
              new Date('1970-01-01').getTime(),
              new Date('1984-12-31').getTime()
            ],
            fillColor: '#775DD0'
          },
          {
            x: 'Piko 40444 2207 Zwart/Grijs, Rode zwl.',
            y: [
              new Date('1984-01-01').getTime(),
              new Date('2003-12-31').getTime()
            ],
            fillColor: '#FEB019'
          }, {
            x: 'Piko 40442 2342 Zwart/Grijs, 3A-Licht Rode zwl.',
            y: [
              new Date('1984-01-01').getTime(),
              new Date('2003-12-31').getTime()
            ],
            fillColor: '#A3A3A3'
          },
          {
            x: 'Piko 40441 2384 NS Cargo',
            y: [
              new Date('1995-01-01').getTime(),
              new Date('2003-12-31').getTime()
            ],
            fillColor: '#FF4560'
          }
          ]
        }
      ],
      chart: {
        height: 300,
        type: 'rangeBar'
      },
      plotOptions: {
        bar: {
          horizontal: true,
          distributed: true,
          dataLabels: {
            hideOverflowingLabels: false
          }
        }
      },
      dataLabels: {
        enabled: false,
        formatter: (val, opts) => {
          const label = opts.w.globals.labels[opts.dataPointIndex];
          const a = moment(val[0]);
          const b = moment(val[1]);
          const diff = b.diff(a, 'days');
          return label + diff;
        },
        style: {
          colors: ['#f3f4f5', '#fff']
        }
      },
      xaxis: {
        type: 'datetime'
      },
      yaxis: {
        show: true
      },
      grid: {
        row: {
          colors: ['#f3f4f5', '#fff'],
          opacity: 0.5
        }, xaxis: {
          lines: {
            show: true
          }
        }
      }
    };
   }

  ngOnInit(): void {
  }

}
